import React, { useEffect, useState } from 'react';
import { Button, Modal, Pagination, Table } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchGetManagerMessage, fetchGetManagerMessagePagination } from '../../../redux/action/managerMessages/getManagerMessage';
import MainLoading from '../../../utils/MainLoading';
import DashboardMainTitle from '../../dashboardTitle/DashboardMainTitle';
import DashboardContent from '../../dashboardWrapper/DashboardContent';
import Wrapper from '../../dashboardWrapper/Wrapper';
import moment from "moment-jalaali";
import { fetchGetSingleManagerMessage } from '../../../redux/action/managerMessages/getSingleManagerMessage';
import { get_user } from '../../../redux/action/login/get_user';
import axios from 'axios';
import { useTranslation } from 'react-i18next';

const CompanyManagerMessages = () => {
    const [show, setShow] = useState(false)
    const dispatch = useDispatch()
    const messages = useSelector(state => state.get_manager_message)
    const single_message = useSelector(state => state.single_manager_message)
    const {t} = useTranslation();
    const lang = localStorage.getItem('lang')
    const handleClose = () => {
        setShow(false)
        setTimeout(function() {
            dispatch(fetchGetManagerMessage())
        }, 500)
    }

    useEffect(() => {
        if(!messages.get_manager_message.data) {
            dispatch(fetchGetManagerMessage())
        }
    }, [])

    const handlePaginate = (e) => {
        e.preventDefault()
        dispatch(fetchGetManagerMessagePagination(e.target.href))
    }

    const showMessage = (id) => {
        setShow(true)
        dispatch(fetchGetSingleManagerMessage(id))
        axios.get('auth/user')
        .then( res => {
            dispatch(get_user(res.data))
            localStorage.setItem("user", JSON.stringify(res.data))
        })
    }

  return (
        <Wrapper>
            <DashboardContent>
                <DashboardMainTitle> {t("dashboard_nav_manager_messages")} </DashboardMainTitle>
                {messages.loading ?
                    <MainLoading />
                :
                    messages.get_manager_message.data &&
                        messages.get_manager_message.data.length ?
                            <>
                            <Table bordered responsive>
                                <thead>
                                    <tr>
                                        <th>{t("title")}</th>
                                        <th>{t("message")}</th>
                                        <th>{t("date")}</th>
                                        <th className='text-center'>{t("view")}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {messages.get_manager_message.data.length &&
                                        messages.get_manager_message.data.map(message => (
                                            <tr key={message.id} style={{background: message.state === "sended" ? 'rgb(220, 255, 95, .2)' : '#fff'}}>
                                                <td style={{ 
                                                    color: message.state === "sended" ? '#000' : '#555',
                                                    fontWeight: message.state === "sended" ? 'bold' : '100',
                                                }}>
                                                    {message.message.title}</td>
                                                <td style={{
                                                    maxWidth: '300px', 
                                                    fontSize: '0.85rem',
                                                    color: message.state === "sended" ? '#000' : '#555',
                                                    fontWeight: message.state === "sended" ? 'bold' : '100',}}>
                                                <p style={{maxHeight: '63px', overflow: 'hidden', padding: '0 .1rem'}}>{message.message.description}</p>
                                                </td>
                                                <td style={{ 
                                                    color: message.state === "sended" ? '#000' : '#555',
                                                    fontWeight: message.state === "sended" ? 'bold' : '100',
                                                }}>
                                                    {lang === 'en' ?
                                                        message.send_time.substr(11, 5)+' - '+message.send_time && message.send_time.substr(0, 10)
                                                    :
                                                        message.send_time.substr(11, 5)} - {moment(message.send_time && message.send_time.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')
                                                    }
                                                </td>
                                                <td className='text-center'><button className={message.state === "sended" ? 'btn btn-success btn-sm px-3' : 'btn btn-secondary btn-sm px-3'} onClick={id => showMessage(message.message.id)}>{t("view")}</button></td>
                                            </tr>
                                        ))}
                                </tbody>
                            </Table> 
                            <div className='pagination_container mt-3'>
                                <Pagination>
                                    {messages.get_manager_message.links ? messages.get_manager_message.links.map(link => (
                                        <Pagination.Item href={link.url} disabled={link.url ? false : true} active={link.active} key={link.label} onClick={id => {handlePaginate(id)}}>
                                            {link.label.replace('&laquo;', '').replace('&raquo;', '')}
                                        </Pagination.Item>
                                    )) : ''}
                                </Pagination>
                            </div>
                            </>
                        :
                            <h6 className='text-center'>{t("There is no message")}</h6>
                }
            </DashboardContent>
            {
                <Modal show={show} onHide={handleClose}>
                    {single_message.loading ?
                            <MainLoading />
                        :
                        single_message.get_single_manager_message.message ?
                        <>
                            <Modal.Header closeButton>
                            <Modal.Title>{single_message.get_single_manager_message.message.title}</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                                <div>
                                    {single_message.get_single_manager_message.message.description}
                                </div>
                                <div className='d-flex justify-content-end mt-4 pt-2' style={{borderTop: '1px solid rgb(247, 245, 245)'}}>
                                    <p className='text-muted text-left'>
                                        {lang === 'en' ?
                                            single_message.get_single_manager_message.message.send_time.substr(11, 5)+' - '+single_message.get_single_manager_message.message.send_time && single_message.get_single_manager_message.message.send_time.substr(0, 10)
                                            :
                                            single_message.get_single_manager_message.message.send_time.substr(11, 5)+' - '+moment(single_message.get_single_manager_message.message.send_time && single_message.get_single_manager_message.message.send_time.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')
                                        }
                                    </p>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                                {t("close")}
                            </Button>
                            </Modal.Footer>
                        </>
                    :
                       <>
                            <Modal.Body>
                                {t("toast_something_went_wrong")}
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" onClick={handleClose}>
                                    {t("close")}
                                </Button>
                            </Modal.Footer>
                       </>
                    }
            </Modal>
        }
        </Wrapper>
    )
};

export default CompanyManagerMessages;
